import { FormState } from 'final-form'
import { debounce, isEqual } from 'lodash'
import { useEffect, useMemo, useRef } from 'react'
import { useFormState } from 'react-final-form'

export interface FormDebouncedValueSpyProps {
  wait?: number

  onChange(formState: FormState<any>): any
}

/** Dispara onChange com debounce, ignorando a notificação inicial do mount. */
export function FormDebouncedValueSpy({ onChange, wait = 500 }: FormDebouncedValueSpyProps) {
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  const initialSkipped = useRef(false)
  const hasFired = useRef(false)
  const lastValues = useRef<unknown>(undefined)

  const debounced = useMemo(() => debounce((state: FormState<any>) => onChangeRef.current(state), wait), [wait])
  useEffect(() => () => debounced.cancel(), [debounced])

  // TODO(#33977): no StrictMode/React 18 os refs sobrevivem ao remount; revalidar que a
  // notificação inicial do segundo mount ainda é descartada.
  useFormState({
    subscription: { values: true, initialValues: true },
    onChange: (state) => {
      if (!initialSkipped.current) {
        initialSkipped.current = true
        return
      }
      if (!hasFired.current) {
        hasFired.current = true
        lastValues.current = state.values
        onChangeRef.current(state)
      } else if (!isEqual(lastValues.current, state.values)) {
        lastValues.current = state.values
        debounced(state)
      }
    },
  })

  return null
}
